import { styled } from "@mui/material/styles";
import { Typography as MuiTypography } from "@mui/material";

export const SessionDetailsContainer = styled("div")(({ theme }) => ({
  display: "flex",
  zIndex: "1",
  flexDirection: "column",
  alignItems: "center",
  alignSelf: "stretch",
  padding: `${theme.space._500} ${theme.space._500} ${theme.space._700} ${theme.space._500}`,
  gap: theme.space._500,

  "@media (max-width: 600px)": {
    padding: `${theme.space._400} ${theme.space._400} ${theme.space._600} ${theme.space._400}`,
  },
}));

export const TitleContainer = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  alignSelf: "stretch",
  gap: theme.space._300,
}));

export const DetailsContainer = styled("div")<{ isPriority?: boolean }>(({ theme, isPriority }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  alignSelf: "stretch",
  gap: theme.space._100,
  color: isPriority ? theme.colors["yellow.300"] : theme.colors["pink.500"],
}));

export const InfoItem = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: theme.space._300,

  color: "inherit",

  "svg" : {
    strokeWidth: 1,
  }
}));

export const SessionNameTypography = styled(MuiTypography)(({ theme }) => ({
  fontFamily: theme.fonts.default,
  fontSize: theme.fontSizes["2xl"],
  fontWeight: theme.fontWeights.bold,
  lineHeight: theme.lineHeights.slim,
  minHeight: "1.625rem",

  color: theme.colors.white,
}));

export const PriorityTypography = styled(MuiTypography)(({ theme }) => ({
  fontFamily: theme.fonts.default,
  fontSize: theme.fontSizes["xl"],
  fontWeight: theme.fontWeights.bold,
  lineHeight: theme.lineHeights.slim,

  color: theme.colors["yellow.300"],
}));

export const InfoTypography = styled(MuiTypography)(({ theme }) => ({
  fontFamily: theme.fonts.default,
  fontSize: theme.fontSizes.sm,
  fontWeight: theme.fontWeights.regular,
  lineHeight: theme.lineHeights.slim,

  color: theme.colors["neutral.400"],
})) as typeof MuiTypography;

export const InfoLinkTypography = styled(InfoTypography)(({ theme }) => ({
  textDecoration: "underline"
})) as typeof MuiTypography;

export const ShowNameTypography = styled(MuiTypography)(({ theme }) => ({
  fontFamily: theme.fonts.default,
  fontSize: theme.fontSizes.md,
  fontWeight: theme.fontWeights.semibold,
  lineHeight: theme.lineHeights.slim,

  color: theme.colors["neutral.400"],
}));
